import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "md:my-28 mt-3 grid gap-y-5" }
const _hoisted_2 = {
  id: "courses-header",
  class: "flex items-center justify-between mb-5 px-3 2xl:px-0"
}
const _hoisted_3 = ["initial", "enter"]
const _hoisted_4 = { class: "mx-8 text-center flex gap-2" }
const _hoisted_5 = ["initial", "enter"]
const _hoisted_6 = { class: "grid grid-cols-12" }
const _hoisted_7 = { class: "col-span-12 md:col-span-6" }
const _hoisted_8 = { class: "text-h-primary-900" }
const _hoisted_9 = { class: "p-input-icon-right w-full mt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = {
  key: 2,
  class: "grid grid-cols-12 gap-3"
}
const _hoisted_12 = {
  key: 3,
  class: "flex justify-end items-center col-span-12 mt-10"
}
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-5 w-full"
}
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { id: "btn-radio" }
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "space-y-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_CardCourseComponent = _resolveComponent("CardCourseComponent")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_motion = _resolveDirective("motion")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("course.title")), 1),
      (_ctx.user.role == 'TEACHER')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-plus",
            label: _ctx.$t('course.create'),
            class: "btn-primary p-button-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('formCourse')))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "tabs",
      class: "overflow-auto",
      initial: _ctx.initialMotion,
      enter: _ctx.enterMotion
    }, [
      _createVNode(_component_TabView, {
        class: "custom-tabs",
        onTabChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeTab($event))),
        scrollable: true,
        activeIndex: _ctx.active
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
            return (_openBlock(), _createBlock(_component_TabPanel, { key: i }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(tab.title), 1)
                ])
              ]),
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "col-span-12 mb-8",
                  initial: _ctx.initialMotion,
                  enter: _ctx.enterMotion
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h5", _hoisted_8, _toDisplayString(tab.title), 1),
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_InputText, {
                          type: "text",
                          modelValue: _ctx.params.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.name) = $event)),
                          placeholder: _ctx.$t('course.search'),
                          class: "p-inputtext-sm",
                          onKeyup: _withModifiers(_ctx.filterCourseByName, ["prevent"])
                        }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
                        _hoisted_10
                      ])
                    ])
                  ])
                ], 8, _hoisted_5)), [
                  [_directive_motion]
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      loader: _ctx.loading
                    }, null, 8, ["loader"]))
                  : (!_ctx.courses || _ctx.courses.length == 0)
                    ? (_openBlock(), _createBlock(_component_EmptyData, {
                        key: 1,
                        data: !_ctx.courses || _ctx.courses.length == 0,
                        label: _ctx.emptyState.description,
                        image: _ctx.emptyState.image
                      }, null, 8, ["data", "label", "image"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.content, (course, i) => {
                          return (_openBlock(), _createBlock(_component_CardCourseComponent, {
                            key: i,
                            course: course,
                            onOnSeeMore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.seeMore($event))),
                            onOnPublish: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmModal($event, ''))),
                            onOnSendToApprove: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmModal($event, 'sendToApprove'))),
                            onOnApprove: ($event: any) => (
                  course.type === 'ADAPTATIVE' || course.type === 'INTERACTIVE'
                    ? _ctx.confirmModal($event, 'toApprove')
                    : _ctx.confirmModal($event, 'toApproveTraditional')
                ),
                            onOnReprove: _ctx.dialogModal,
                            onOnEdit: ($event: any) => (
                  _ctx.go.redirectToPage('chapters', {
                    id: course.id,
                    type:
                      course.type === 'INTERACTIVE' ? course.type : undefined,
                    h5pId: course.h5p?.h5pId ?? undefined,
                  })
                )
                          }, null, 8, ["course", "onOnApprove", "onOnReprove", "onOnEdit"]))
                        }), 128))
                      ])),
                (_ctx.params?.total! > _ctx.params?.size)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_Paginator, {
                        rows: _ctx.params?.size,
                        totalRecords: _ctx.params?.total,
                        rowsPerPageOptions: [12, 20, 30],
                        first: _ctx.params.page * _ctx.params.size + 1,
                        onPage: _ctx.paginate
                      }, null, 8, ["rows", "totalRecords", "first", "onPage"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ], 8, _hoisted_3)), [
      [_directive_motion]
    ]),
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } }, {
      message: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(slotProps.message.message), 1),
          (!_ctx.course.adaptive && _ctx.user.role == 'ADMINISTRATOR')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radios, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_RadioButton, {
                          id: "radio-listed",
                          modelValue: _ctx.courseType,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.courseType) = $event)),
                          inputId: item.value,
                          value: item.value,
                          disabled: item.disabled,
                          name: "courseType",
                          class: "custom-radio"
                        }, null, 8, ["modelValue", "inputId", "value", "disabled"]),
                        _createElementVNode("label", {
                          for: item.value,
                          class: _normalizeClass(`ml-2 cursor-pointer ${
                      item.disabled ? 'text-gray-400' : ''
                    }`)
                        }, _toDisplayString(item.name), 11, _hoisted_18)
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createVNode(_component_v_icon, {
                          name: "md-info-outlined",
                          class: "text-h-primary-500"
                        })
                      ])), [
                        [
                          _directive_tooltip,
                          
                    `
                        ${
                          item.value == 'LISTED'
                            ? _ctx.$t('course.form.types.listed')
                            : _ctx.$t('course.form.types.nonListed')
                        }`
                  ,
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogModals,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogModals) = $event)),
      draggable: false,
      style: { width: '80vw', maxWidth: '700px' },
      modal: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Reprovar", en: "Reprove" })) + " " + _toDisplayString(_ctx.course.name), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "btn-outline",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogModals = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Cancelar",
              en: "Cancel",
            })), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => {
            _ctx.toApprove(_ctx.course, false);
            _ctx.dialogModals = false;
          })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Reprovar",
              en: "To reprove",
            })), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Informe abaixo o motivo da reprovação.",
              en: "Please provide the reason for disapproval below.",
            })), 1),
          _createVNode(_component_Textarea, {
            id: "reason",
            type: "text",
            name: "reason",
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reason) = $event)),
            rows: "5",
            cols: "30"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}